<div class="row flex-column flex-md-row centered-content" [class.past]="isPast">
  <!-- Added flex-column for small screens -->
  <div class="col-12 col-md-5 mb-2 mb-md-0">
    <!-- Added mb-2 for spacing on small screens -->
    <div class="fw-bold">{{ show.date | date : "longDate" }}</div>
    <div>{{ show.title }}</div>
  </div>
  <div class="col-12 col-md-5 mb-2 mb-md-0">
    <!-- Added mb-2 for spacing on small screens -->
    {{ show.location }}
  </div>
  <div class="col-12 col-md-2 text-center">
    <a
      href="{{ show.url === '' ? '/contact' : show.url }}"
      target="_blank"
      class="py-2 mt-1 no-line more-info-btn"
      >More Info</a
    >
  </div>
</div>
